import { VolunteerActivism } from "@mui/icons-material";

const voluntaryWorkResource = {
    title: "Voluntary Work History",
    singular: "Voluntary Work",

    collectionField: "voluntaryWorkHistory",
    displayField: "organisationName",
    icon: VolunteerActivism,

    columns: [
        {
            field: "organisationName",
            header: "Organisation Name",
            type: "text"
        },
        {
            field: "position",
            header: "Position",
            type: "text"
        },
        {
            field: "startDate",
            header: "Start Date",
            type: "date"
        },
        {
            field: "endDate",
            header: "End Date",
            type: "date"
        },
        {
            field: "hoursAttended",
            header: "Hours Attended",
            type: "number"
        }
    ],

    fields: {
        organisationName: {
            name: "organisationName",
            label: "Organisation Name",
            type: "text",
            required: true
        },
        startDate: {
            name: "startDate",
            label: "Start Date",
            type: "date",
            required: true
        },
        endDate: {
            name: "endDate",
            label: "End Date",
            type: "date"
        },
        position: {
            name: "position",
            label: "Position",
            type: "text"
        },
        hoursAttended: {
            name: "hoursAttended",
            label: "Hours Attended",
            type: "number"
        },
        natureOfWork: {
            name: "natureOfWork",
            label: "Nature of Work",
            type: "text"
        }
    }
};

export default voluntaryWorkResource;
